import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { ISearchScreen } from './types';

const initialState: ISearchScreen = {
  searchedItems: {},
};

const slice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    searchItems: (state, action: PayloadAction<string>) => {
      state.searchedItems.status = RequestStatus.RUNNING;
    },
    searchItemsSuccess: (state, action) => {
      state.searchedItems.status = RequestStatus.SUCCESS;
      state.searchedItems.data = action.payload;
    },
    searchItemsFailed: (state, action: PayloadAction<IRequestFailed>) => {
      state.searchedItems.status = RequestStatus.ERROR;
      state.searchedItems.data = action.payload;
    },
  },
});

export default slice.reducer;

export const { searchItems, searchItemsSuccess, searchItemsFailed } = slice.actions;
